import { RequestService } from '@/api/services/request.service';
import { queryKeys } from '@/tanstack-query/query-keys';
import { FishingArea, FishingAreaInProductInfo } from '@/types/fishing-area';
import { useQuery } from '@tanstack/react-query';

export type FishingAreasResponse = FishingArea[];

export const getFishingAreas = async (): Promise<FishingAreasResponse> => {
	const request = RequestService.getInstance();
	try {
		const { data } = await request.get(`${process.env.HOST}/api/v2/fishing-areas/`);

		return data;
	} catch (error) {
		throw new Error(
			error.response?.data?.message ?? error?.statusText ?? 'Ошибка при получении районов промысла',
		);
	}
};

export type FishingAreaResponse = FishingAreaInProductInfo;

export const getFishingArea = async (fishingAreaId: string): Promise<FishingAreaResponse> => {
	const request = RequestService.getInstance();
	try {
		const { data } = await request.get(`${process.env.HOST}/api/v2/fishing-areas/${fishingAreaId}`);

		return data;
	} catch (error) {
		throw new Error(
			error.response?.data?.message ?? error?.statusText ?? 'Ошибка при получении района промысла',
		);
	}
};

export const useFishingAreas = () =>
	useQuery({
		queryKey: queryKeys.fishingAreas,
		queryFn: getFishingAreas,
		staleTime: Infinity,
	});
